import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './InputSuffix.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  suffix: string | number;
};

export const InputSuffix: FC<Props> = memo(({ suffix }) => {
  return <div className={cx(styles['suffix'])}>{suffix}</div>;
});
InputSuffix.displayName = 'InputSuffix';
